import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'tpc-energy',
    templateUrl: './energy.component.html',
    styleUrls: ['./energy.component.css']
})
export class EnergyComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/energy/energy.component.ts